<template>
  <div class="about">
    <b-container>
		<b-row>
             <b-col class="text-center">
            <router-link to="/">Home</router-link> |
            <router-link to="/viewUnresolvedJobs">View Jobs</router-link> |
            <router-link to="/viewResolvetickets">View Tickets</router-link> |
            <router-link to="/createTicket">Create Tickets</router-link> 
            <br>
            <br>
            </b-col>
        </b-row>
        <b-row>
         <b-col class="text-center">
            <img src="img/logo.png" class="center-block" alt="EnergyDrive">
            </b-col>
        </b-row><br>
		<b-row >
             <b-col class="text-left">
			<small>View my unresolved Jobs</small><hr>
        </b-col>
		</b-row>
        <b-row>
            <b-col>
                Search
                <b-input type="text" name="resolveComment" id="resolveComment" class="form-control" value='' v-model="searchTickets"></b-input><br>
            </b-col>
        </b-row>
        <b-row >
				<select class="form-control" id="filter" style="overflow:scroll;"   v-model="selectedOption" @change="viewBySelectionChanged">
                    <option value=0>Arranged by Priority</option>
                    <option value=1>Arranged by Date</option>
                    <option value=2>Filter by Sites </option>				
				</select>
				<br><br>
		</b-row>
		<b-row v-if="selectBySite" >
				<select class="form-control" id="filterSites" style="overflow:scroll;"  v-model="selectedSite" @change="siteSelectionChanged">
				<option  value=0 disabled s>Select Site</option>
                <option v-for="site in sites"  v-bind:key="site.idSite" :value="site.idSite" >{{site.SiteName}} [{{site.nrTickets}} ]</option>
				<!-- Options via vue -->  
				</select>
				<br><br>
		</b-row>
        <component-viewTicket v-for="ticket in filteredTickets" v-bind:key="ticket.idTicket" :idTicket="ticket.idTicket" :ticket="ticket"></component-viewTicket>

     </b-container>
      <b-row v-if="showNoJobs">
           <b-col class="text-center"><br>
          <h3> You have no unresolved jobs</h3>
          </b-col>
      </b-row>    
  </div>
</template>

<script>
import axios from 'axios';
import viewTicket from '../components/viewTicket.vue'
import moment from 'moment';
export default {
  name: 'viewMyJobs',
 
   components: {
    'component-viewTicket' : viewTicket
   },
  data: () => ({
        employee : "",
        idEmployee : -1,
        selectBySite : false,
        selectByPriority : false,
        selectedOption : 0,
        selectedSite : 0,
        viewticketFilter : 2,
        searchTickets : "",
        sites : null,
        showNoJobs : false,
        tickets : []
  }),
  methods: {
      viewBySelectionChanged : function() {
          
          if ( this.selectedOption == 0 )
          {
              this.selectByPriority = true;
              this.selectBySite = false;

          }
          if ( this.selectedOption == 1 )
          {
                this.selectByPriority = false;
                this.selectBySite = false;

          }
          if ( this.selectedOption == 2 )
          {
              this.selectByPriority = false;
              this.selectBySite = true;
              

          }


      },
      siteSelectionChanged : function() {
         
            

      },
      sortTicketsByPriority : function (a,b) {
            var dateA = moment(a.TicketIssued);
            var dateB = moment(b.TicketIssued);
            //console.log(dateA)
            //console.log(dateB)
            
            var an = a.Priority,
                bn = b.Priority;
            //console.log(an+" vs "+bn);    
            switch (an)
            {
                case  2 : an = 0; break; //'LOW'
                case  4 : an = 1; break; //'STANDARD'
                case  1 : an = 2; break; //'HIGH'
                case  3 : an = 3; break; //Critical
                default : an = -1; break;
            }

            switch (bn)
            {
                case  2 : bn = 0; break; //'LOW'
                case  4 : bn = 1; break; //'STANDARD'
                case  1 : bn = 2; break; //'HIGH'
                case  3 : bn = 3; break; //Critical
                default : bn = -1; break;
            }

            if ( an == bn )
            {
                console.log("Same priority, order by date")
                if ( dateA.isAfter(dateB))
                    return -1;
                else
                    return 1;	
            }
            else
            {
                if(an > bn) {
                    return -1;
                }
                if(an < bn) {
                    return 1;
                }
            }
            return 0;
      },
      sortTicketsByDate : function (a,b) {
            var dateA = moment(a.TicketIssued);
            var dateB = moment(b.TicketIssued);
            //console.log(dateA)
            //console.log(dateB)
            if ( dateA.isAfter(dateB))
                return -1;
            else
                return 1;	
            
      }
  },
  computed: {
    filteredTickets : function () {
       
      var self = this;
      var ticketsFilteredButUnsorted = self.tickets.filter(function (ticket) {
            if ( self.selectedOption == 2  ) // filter by site
            {
                // show only site tickets
                if ( ticket.idSite == self.selectedSite) 
                return true;
                else
                return false;
            }
            else
            {
                // show all tickets
                let searchStr = ""+ticket.idTicket+ticket.Description;
                let regedit = "/"+self.searchTickets+"/gm";
                if ( self.searchTickets != "" )
                {
                    console.log("Regex")
                    console.log(searchStr.match(regedit));
                    if ( searchStr.match(regedit) )
                        return true;
                    else
                        return false;
                }
                else
                    return true;
            }
      })
     
      if ( self.selectedOption == 0 ) // sort by priority
      {
          //console.log("Executed sort by Priority");
         return ticketsFilteredButUnsorted.sort(self.sortTicketsByPriority);
      }
      if ( self.selectedOption == 1 ) // sort by priority
      {
          //console.log("Executed sort by Date");
         return ticketsFilteredButUnsorted.sort(self.sortTicketsByDate);
      }
      
        //console.log("No sorting applied");
        return ticketsFilteredButUnsorted;
      
    }
    },
  mounted () {

    var objectData = this;      
    
    objectData.tickets = [];
    //console.log("siteChanged");
    axios
      .get(localStorage.getItem('ticketCopURL') +'/getSites',
      {
            headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
      })
      .then(function (response) {
         
          for( var i = 0 ; i < response.data.length ;i++ )
          {
              response.data[i].nrTickets = 0;

          }
          // console.log(response);
          objectData.sites = response.data;
          

            axios.get(localStorage.getItem('ticketCopURL') +'/viewSelectedTickets', {
            //axios.get('https://energydrive.dnsalias.com/ticketcop_dev/viewJobs', {
            params: {
                    idSite : objectData.selectedSite,
                    isJob : 1,
                    isEmployeeBased : 1,
                    idEmployee : objectData.idEmployee // use clin as test case
            },
                headers: {"Authorization" : "Bearer "+localStorage.getItem('jwt') }
            })
            .then(function (response) {
            //console.log(response);
            if ( response.data != "error" )
            {
                objectData.tickets = response.data;
                if (response.data.length < 1 )
                objectData.showNoJobs = true;
                
                console.log("Got Tickets here");
                //console.log(response.data);
                for( var i = 0 ;i < response.data.length ; i++)
                {
                    for( var j = 0 ;j < objectData.sites.length ; j++)
                    {
                        if ( response.data[i].idSite == objectData.sites[j].idSite )
                        {
                            objectData.sites[j].nrTickets++;
                            console.log("Incremented");
                            
                        }
                    }

                }
            }
            else
            {
                console.log("Error response");
            }
            
            
            //mainObject.ticketTagSubCategory_visible = true;

            })
            .catch(function (error) {
                console.log(error);
            })
            .then(function () {
            // always executed
            console.log("Got all unresolved tickets for user");

            
            }); 
    
        }
      )
  }
  ,
   created: function () {
       /*console.log("Created");
       console.log(this.$route.params);
       this.employee = this.$route.params.employee;
       this.idEmployee = this.$route.params.idemployee;*/
       let employee = localStorage.getItem('employee');
       let idemployee = localStorage.getItem('idemployee');
       this.employee = employee;
       this.idEmployee = idemployee;


   }
}
</script>
